import { vi } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';
import {
  DatePicker as UiDatePicker,
  type DatePickerProps as UiDatePickerProps,
} from '@repo/ui/src/components/date-picker';

export type DatePickerProps = Omit<UiDatePickerProps, 'locale' | 'weekStartsOn'>;

/** Dashboard-bound DatePicker: vi locale, week starting Monday, i18n labels. */
export function DatePicker({ placeholder, clearLabel, ...rest }: DatePickerProps) {
  const { t } = useTranslation('common');
  return (
    <UiDatePicker
      {...rest}
      locale={vi}
      weekStartsOn={1}
      placeholder={placeholder ?? t('picker.selectDate')}
      clearLabel={clearLabel ?? t('picker.clear')}
    />
  );
}
